
import { useTranslation } from "react-i18next";

import classes from "../../../../../assets/css/showCardInfo.module.css";
import icons from "../../../../../Data/icons";

const ContractsDetalis = ({ contracts }) => {
  const { t } = useTranslation();

  const titles = {
    id: "#", 
    employe:t("employe"),
    designation:t("designation"),
    level:t("level"),  
    company:t("company"),
    start_date:t("start_date"),
    duration:t("duration"),
    duration_type:t(" duration type") 

  };
  const IdCardIcon = icons.idCard
  const EmployIcon = icons.employ
  const CompanyIcon = icons.company
  const LevelIcon = icons.levels
  const DateIcon = icons.date
 
  const { id, employe , designation , level ,company , start_date , duration ,duration_type } = contracts;
  return (
    <div className={classes.container}>
        <div className={classes.tableCard}>
      <div className={classes.tableCardBody}>
        <ul className={classes.ListGroup}>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
              <IdCardIcon/>   
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.id}</h5>
              <p>{id}</p>
            </div>
          </li>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
            <EmployIcon/>
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.employe}</h5>
              <p className={classes.listPargrah}>{employe}</p>
            </div>
          </li>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
  
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.designation}</h5>
              <p className={classes.listPargrah}>{designation}</p>
            </div>
          </li>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
          <LevelIcon/>
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.level}</h5>
              <p className={classes.listPargrah}>{level}</p>
            </div>
          </li>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
            <CompanyIcon/>
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.company}</h5>
              <p className={classes.listPargrah}>{company}</p>
            </div>
          </li>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
            <DateIcon/>
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.start_date}</h5>
              <p className={classes.listPargrah}>{start_date}</p>
            </div>
          </li>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
        
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.duration}</h5>
              <p className={classes.listPargrah}>{duration}</p>
            </div>
          </li>
          <li className={classes.listItemGroup}>
            <div className={classes.listIcon}>
 
            </div>
            <div>
              <h5 className={classes.listTitle}>{titles.duration_type}</h5>
              <p className={classes.listPargrah}>{duration_type}</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    </div>
  );
};

export default ContractsDetalis;
